export default __webpack_public_path__ + "static/media/rowingBlazers-masterImage.704a18eb.png";